module.exports = __webpack_public_path__ + "img/lock_image.80103457.jpg";